/**
 * Казахская локаль ApexCharts — в самой библиотеке её нет
 */
export default {
    name:    'kk',
    options: {
        days: [
            'Жексенбі',
            'Дүйсенбі',
            'Сейсенбі',
            'Сәрсенбі',
            'Бейсенбі',
            'Жұма',
            'Сенбі',
        ],
        months: [
            'Қаңтар',
            'Ақпан',
            'Наурыз',
            'Сәуір',
            'Мамыр',
            'Маусым',
            'Шілде',
            'Тамыз',
            'Қыркүйек',
            'Қазан',
            'Қараша',
            'Желтоқсан',
        ],
        shortDays:   ['Жс', 'Дс', 'Сс', 'Ср', 'Бс', 'Жм', 'Сб'],
        shortMonths: [
            'Қаң',
            'Ақп',
            'Нау',
            'Сәу',
            'Мам',
            'Мау',
            'Шіл',
            'Там',
            'Қыр',
            'Қаз',
            'Қар',
            'Жел',
        ],
        toolbar: {
            exportToCSV:   'CSV сақтау',
            exportToPNG:   'PNG сақтау',
            exportToSVG:   'SVG сақтау',
            menu:          'Мәзір',
            pan:           'Жылжыту',
            reset:         'Үлкейтуді қалпына келтіру',
            selection:     'Таңдау',
            selectionZoom: 'Үлкейтіп таңдау',
            zoomIn:        'Үлкейту',
            zoomOut:       'Кішірейту',
        },
    },
};
